import { cn } from '../../../lib/stylingUtils';

export type FontThinProps = {
  children: React.ReactNode;
  className?: string;
};

export const FontThin = ({ children, className }: FontThinProps) => (
  <span className={cn('@FontThin', 'font-thin', className)}>{children}</span>
);

export type FontLightProps = {
  children: React.ReactNode;
  className?: string;
};

export const FontLight = ({ children, className }: FontLightProps) => (
  <span className={cn('@FontLight', 'font-light', className)}>{children}</span>
);

export type FontNormalProps = {
  children: React.ReactNode;
  className?: string;
};

export const FontNormal = ({ children, className }: FontNormalProps) => (
  <span className={cn('@FontNormal', 'font-normal', className)}>
    {children}
  </span>
);

export type FontMediumProps = {
  children: React.ReactNode;
  className?: string;
};

export const FontMedium = ({ children, className }: FontMediumProps) => (
  <span className={cn('@FontMedium', 'font-medium', className)}>
    {children}
  </span>
);

export type FontSemiBoldProps = {
  children: React.ReactNode;
  className?: string;
};

export const FontSemiBold = ({ children, className }: FontSemiBoldProps) => (
  <span className={cn('@FontSemiBold', 'font-semibold', className)}>
    {children}
  </span>
);

export type FontBoldProps = {
  children: React.ReactNode;
  className?: string;
};

export const FontBold = ({ children, className }: FontBoldProps) => (
  <span className={cn('@FontBold', 'font-bold', className)}>{children}</span>
);
